import { configureStore } from '@reduxjs/toolkit'
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from '@reduxjs/toolkit';
import userReducer from '../Slices/userSlice'; // <-- use reducer not slice object
import customerReducer from '../Slices/customerSlice';
import officeReducer from '../Slices/officeSlice';
import branchReducer from '../Slices/branchSlice';

const persistConfig = {
  key: "root",
  storage,
}

const reducer = combineReducers({
  auth: userReducer, // ✅ Use reducer not whole slice
  customer: customerReducer,
  office : officeReducer,
  branch : branchReducer
})

const persistedReducer = persistReducer(persistConfig, reducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // ✅ disables warning
    }),
})

export const persistor = persistStore(store);
